The scheme ID of the suggested job categories.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
